<template>
	<on-click-outside :do="close">
		<fetch-json :url="searchUrl">
			<template slot-scope="{json:entities,loading}">
				<div class="search-field">
					<ul class="search-field-dropdown" v-if="startSearch && entities && entities.length>0" ref="items">
						<li v-for="(entity,i) in entities" :key="entity.key" class="search-field-dropdown-item" :class="{'is-active': i === highlightIndex}" @click="select(entity)">
							<p>{{entity.kn}}</p>
						</li>
					</ul>
					<div class="field">
						<div class="control is-medium  has-icons-right" :class="{'is-loading':loading}">
							<input class="input" :class="inputClass" type="text" :placeholder="placeholder"
								   ref="input"
								   @input="initSearch($event.target.value)"
								   @keydown.esc="close"
								   @keydown.up.prevent="highlightPrev(entities.length)"
								   @keydown.down.prevent="highlightNext(entities.length)"
								   @keydown.enter.prevent="selectHighlighted(entities)">
							<span class="icon is-small is-right">
								<a class="delete" @click="clear" v-if="searchText && !loading"></a>
								<img src="../../assets/svg/search.svg" v-else />
							</span>
						</div>
					</div>
				</div>
			</template>
		</fetch-json>
	</on-click-outside>
</template>
<script>
	import _debounce from 'lodash.debounce'
	import OnClickOutside from '@/components/common/OnClickOutside'
	export default {
		props: {
			value: {
				type: Object
			},
			url: {
				required: true,
				type: String
			},
			placeholder: {
				default: '',
				type: String
			},
			inputClass: {
				default: '',
				type: String
			},
			searchDelay: {
				type: Number,
				default: 500
			}
		},
		data() {
			return {
				searchUrl: '',
				searchText: '',
				highlightIndex: 0,
				startSearch: false
			}
		},
		components: {
			OnClickOutside
		},
		methods: {
			initSearch(value) {
				if (value === '') {
					this.clear();
					return;
				}
				this.startSearch = true;
				this.searchText = value;
				this.highlightIndex = 0;

			},
			updateUrl() {
				this.$emit('start-search');
				this.searchUrl = `${this.url}?search=${this.searchText}`;
			},
			close() {
				this.startSearch = false;
			},
			clear() {
				this.searchText = '';
				this.$refs.input.value = '';
				this.startSearch = false;
				this.$emit('input', null);
			},
			select(item) {
				this.$emit('input', item);
				this.startSearch = false;
				this.$refs.input.value = item.kn;
				this.highlightIndex = 0;
			},
			selectHighlighted(items) {
				if (items.length === 0 || !this.startSearch)
					return;
				this.select(items[this.highlightIndex]);
			},
			highlight(length, index) {
				this.highlightIndex = index;
				if (this.highlightIndex < 0)
					this.highlightIndex = length - 1;
				if (this.highlightIndex > length - 1)
					this.highlightIndex = 0;
				this.$refs.items.children[this.highlightIndex].scrollIntoView({ block: 'nearest' });
			},
			highlightPrev(length) {
				this.highlight(length, this.highlightIndex - 1);
			},
			highlightNext(length) {
				this.highlight(length, this.highlightIndex + 1);
			}
		},
		watch: {
			searchText(newVal) {
				if (newVal === '')
					this.updateUrl();
				else
					this.debouncedUrl();
			}
		},
		created() {
			this.debouncedUrl = _debounce(() => {
				this.updateUrl();
			}, this.searchDelay);
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../assets/sass/main.scss';	

	.search-field-dropdown {
		position: absolute;
		z-index: 500;
		top: 3.3rem;
		width: 100%;
		max-height: 400px;
		overflow-y: auto;
		background: #FFFFFF;
		border: 1px solid $grey-lighter;
		box-sizing: border-box;
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
		border-radius: 6px;
	}

	.search-field-dropdown-item {
		cursor: pointer;
		display: block;
		padding: 0.5rem 1.5rem;
		color: black;
		font-size: 14px;
	}

		.search-field-dropdown-item:first-child {
			padding: 1rem 1.5rem 0.5rem;
		}

		.search-field-dropdown-item:last-child {
			padding: 0.5rem 1.5rem 1rem;
		}

		.search-field-dropdown-item:hover {
			background-color: $white-bis;
		}

		.search-field-dropdown-item.is-active {
			background-color: $white-ter;
		}
</style>
